import { render, staticRenderFns } from "./select-local.vue?vue&type=template&id=1c9ef6dc&"
import script from "./select-local.vue?vue&type=script&lang=js&"
export * from "./select-local.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports